export const ADD_ACCOUNT_BEGIN = "ADD_ACCOUNT_BEGIN"
export const ADD_ACCOUNT_ERROR = "ADD_ACCOUNT_ERROR"
export const ADD_ACCOUNT_SUCCESS = "ADD_ACCOUNT_SUCCESS"
export const ADD_ITINERARY_BEGIN = "ADD_ITINERARY_BEGIN"
export const ADD_ITINERARY_ERROR = "ADD_ITINERARY_ERROR"
export const ADD_ITINERARY_SUCCESS = "ADD_ITINERARY_SUCCESS"